module.exports = __webpack_public_path__ + "media/images/icon_popup_area_sp-e7455a557197f5f9d36796c64c18edfa.png";